var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgScaleOut = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "inherit",
  className: "scaleOut_svg__svg-safari-fix",
  viewBox: "0 0 20 20",
  "aria-hidden": props["aria-label"] || props["aria-labelledby"] ? undefined : true
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M17.437 3.014a.8.8 0 0 0-.18-.268l-.003-.004a.83.83 0 0 0-.587-.242h-5a.833.833 0 1 0 0 1.667h2.988l-3.578 3.577a.833.833 0 0 0 1.179 1.179l3.577-3.578v2.988a.833.833 0 0 0 1.667 0V3.331a.8.8 0 0 0-.063-.317M2.563 16.986q.06.148.18.268l.003.004a.83.83 0 0 0 .587.242h5a.833.833 0 1 0 0-1.667H5.345l3.578-3.577a.833.833 0 1 0-1.179-1.179l-3.577 3.578v-2.988a.833.833 0 1 0-1.667 0v5.002q.002.17.063.317",
  clipRule: "evenodd"
})));
export default SvgScaleOut;